import React from "react";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";
import ViewPost from "./View";
import EditPost from "./Update";

const UpdateIndex = () => {
    return (
        <MainLayout>
            <FeedLayout>
                <EditPost/>
            </FeedLayout>
        </MainLayout>
    );
};

export default UpdateIndex;
